import React from "react"
import { Div, Text } from "atomize"
import { motion } from "framer-motion"
import { theme } from "../settings/config"

// Poche scelte dentro una pastiglia sola: si vedono tutte insieme e si vede
// quale è quella scelta.
//
// Serve dove un interruttore direbbe una bugia. Luce e riscaldamento si
// accendono e si spengono davvero; il campo pagato da te non è "spento", è
// l'altro modo di fare la stessa cosa — e sceglierlo non è riaccendere
// niente, è dire quale dei due è. Vale uguale per il tema: chiaro, scuro e
// "come il telefono" sono tre modi, nessuno dei tre è l'assenza degli altri.
function SegmentedPill({ label, options, selected, onChange }) {
	return (
		<Div
			d="flex"
			align="center"
			w="fit-content"
			p="3px"
			rounded="15px"
			bg={theme.colors.gray_light}
			style={{ gap: "3px" }}>
			{/* Il nome della cosa, non una delle due scelte: non si tocca e non
			    si accende. Sta nel colore delle altre pastiglie della riga, così
			    non si confonde con l'opzione che non hai scelto. */}
			{label && (
				<Text
					textSize="body"
					textColor={theme.colors.gunmetal}
					p={{ l: "0.5rem", r: "0.15rem" }}
					style={{ whiteSpace: "nowrap" }}>
					{label}
				</Text>
			)}

			{options.map(option => {
				const isSelected = option.value === selected

				return (
					<motion.div key={option.value} whileTap={{ scale: 0.95 }}>
						<Div
							p="0.15rem 0.6rem"
							rounded="12px"
							cursor="pointer"
							transition
							bg={isSelected ? theme.colors.gunmetal_fill : "transparent"}
							onClick={() => !isSelected && onChange(option.value)}>
							<Text
								textSize="body"
								textWeight={isSelected ? "bold" : "normal"}
								textColor={
									isSelected ? theme.colors.white : theme.colors.text_light
								}
								style={{ whiteSpace: "nowrap" }}>
								{option.text}
							</Text>
						</Div>
					</motion.div>
				)
			})}
		</Div>
	)
}

export default SegmentedPill
